import { cn } from '@utils/cn';
import { doSomeMagicWithKey } from '@utils/hotkeys';
import React from 'react';
// import { isHotkeyPressed } from "react-hotkeys-hook";

export const ShortcutKbd = React.forwardRef<
  HTMLDivElement,
  { children: string; className?: string }
>(({ children, className }, ref) => {
  // const isPressed = isHotkeyPressed([children]);

  return (
    <div ref={ref} className={cn('flex-center space-x-[2px]', className)}>
      <kbd
      // // the `isHotkeyPressed` doesn't work with the `meta` key on mac
      // data-pressed={isPressed}
      >
        {children.split('+').map((key, i) => (
          <span key={key} className={cn(i !== 0 && 'ml-[2px]')}>
            {doSomeMagicWithKey(key)}
          </span>
        ))}
      </kbd>
    </div>
  );
});

ShortcutKbd.displayName = 'ShortcutKbd';
